import React, { FC, useState } from 'react';
import { MultiValue } from 'react-select';
import { MultiSelectDropdownInput } from '../Select/MultiSelectDropdownInput';
import { Option } from '../Select/interfaces/option.interface';
import { ItemSelectionDropdownProps } from './props';
import './styles.scss';

export const ItemSelectionDropdown: FC<ItemSelectionDropdownProps> = ({
  defaultValue,
  onSelect,
  options,
  placeholder,
  onInputChange,
  inputValue,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<MultiValue<Option>>(defaultValue || []);

  return (
    <MultiSelectDropdownInput
      onInputChange={onInputChange}
      inputValue={inputValue}
      className="item-selection"
      value={selectedOptions}
      options={options}
      placeholder={placeholder}
      onChange={(selectedOptions, actionMeta) => {
        if (!selectedOptions) {
          return;
        }

        setSelectedOptions(selectedOptions);

        onSelect?.(selectedOptions, actionMeta);
      }}
    />
  );
};
